import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import {  Observable,  } from 'rxjs';
import { DataStateChangeEventArgs, } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { DatePipe } from '@angular/common';
import { GetTimesheetverificationBO } from './timesheetverification.model';
import { GeneralService } from 'src/app/service/general.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TimesheetVerificationService extends Subject<DataStateChangeEventArgs>{
  originaldata: any = [];
  childData: any = [];
  idsList: any = [];
  public details: any = [];
  errorlist: any = [];
  serialno: any;
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService, public datePipe: DatePipe) {
    super();
  }
  public outputValues(state: GetTimesheetverificationBO): void {
    this.getList(state).subscribe(x => super.next(x));
  }
  getList(state?: GetTimesheetverificationBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/TimeSheetVerfication/GetTimeSheetVerficationFilter", state)
      .pipe(map(
        (response: any) => (<any>{
          result: response['timesheetlist'],
          count: response['totalCount'],
          ids: response['idarray'],
          verificationGuid:response['verificationGuid']
        }))).pipe(map((e: any) => {
          e.result = this.setdata(e);
          return e;
        })
        )
  }
  setdata(data) {
    let parentArray = [];
    let childArray = [];
    this.details = [];
    this.errorlist = [];
    let clientId: number;
    let companyId: number;
    let grouppayorId: number;
    let grouppayorServiceId: number;
    let clientAuthId: number;
    let employeeId: number;
    let payrname: string;
    let supervisingEmployeeId:number;
    this.originaldata = data.result;
    this.idsList = data.ids;
    let objArray: any = [];
    if (data.result.length != 0) {
      data.result.forEach(element => {
        this.serialno = element.serialNo
        // ----------for errolist-----------
        let btncount = 0;
        let buttoncolor: any;
        clientId = element.clientId;
        companyId = element.companyId;
        grouppayorId = element.groupPayorId;
        grouppayorServiceId = element.groupPayorServiceId;
        clientAuthId = element.clientAuthorizationId;
        employeeId = element.employeeId;
        payrname = element.payorName;
        supervisingEmployeeId = element.supervisingProviderId
        let certificateId=element.certificateId
        element.error.forEach(element => {
          if (element.isValid == true) {
            this.global.loading = false;
            element.color = "Green";
            element.colr = 'black'
            element.status = 'Valid'
            //  this.buttoncolor = "Green"
          }
          if (element.isValid == false) {
            element.color = "Red"
            element.colr = 'Red'
            //  this.buttoncolor = "red"
            element.status = 'Not valid'
            btncount += 1;
          }
          // if (btncount > 0) {
          //   buttoncolor = "Red"
          // }
          // else {
          //   buttoncolor = "Green"
          // }
          element.serialno = this.serialno;
          element.clientId = clientId;
          element.companyId = companyId;
          element.groupPayorId = grouppayorId;
          element.grouppayorServiceId = grouppayorServiceId;
          element.clientauthId = clientAuthId;
          element.employeeId = employeeId;
          element.payorName = payrname;
          element.clientcertificationId=certificateId;
          element.supervisingEmployeeId=supervisingEmployeeId;
          this.errorlist.push(element);
        });
        if (element.claimStatus == "Validate") {
          element.bit = 1;
          element.color = 'red',
          buttoncolor="Red"
        }
        else if(element.claimStatus == "OverUnits"){
          element.bit = 0;
          element.color = 'yellow'
          buttoncolor="Yellow"
        }
        else {
          element.bit = 0;
          element.color = 'green'
          buttoncolor="Green"
        }
        let fromDate = this.datePipe.transform(element.fromDate, "MM/dd/yyyy")
        let toDate = this.datePipe.transform(element.toDate, "MM/dd/yyyy")
        let obj =
        {
          clientName: element.clientName,
          client_InsuranceNo: element.client_InsuranceNo,
          'archieveNotes':element.archieveNotes,
          'clientLocation':element.clientLocation,
          'employeeLocation':element.employeeLocation,
          'payorName': element.payorName,
          'fromDate': fromDate,
          "employeeID": element.employeeId,
          'toDate': toDate,
          // 'HireDate': new Date(704692800000),
          'totalHours': element.totalHours,
          'employee': element.employee,
          'units':element.units,
          'employee_UMPI': element.employee_UMPI,
          'billingpayorID': element.billingpayorID,
          'totalAmountBIlled': element.totalAmountBIlled,
          'payableHours':element.payableHours,
          'totalAmountExpected':element.totalAmountExpected,
          'claimStatus': element.claimStatus,
          'serviceCode': element.serviceCode,
          'errorNotes': element.errorNotes,
          'serialNo': element.serialNo,
          'buttoncolor': buttoncolor,
          'color': element.color,
          'bit': element.bit,
          'validate': '',
          'timesheetId': element.timesheetId,
          'isApproved':element.isApproved,
          'billingLovLid':element.billingLovLid,
          'isPaid':((element.isPaid==true) ? "YES":"NO")
        }
        objArray.push(obj);
        // ----------for childgrid data-----------
        element.lineItem.forEach(element => {
          if (element.lineStatus == "Validate") {
            element.bit = 1;
            // element.color = 'red'
          }
          else {
            element.bit = 0;
            // element.color = 'green'
          }
          let serviceDate = this.datePipe.transform(element.serviceDate, "MM/dd/yyyy")

        //   let perdaymin1 = element?.hoursPerDay?.toString().split('.');
       
        //   if(perdaymin1!=null && perdaymin1!=undefined && perdaymin1!='')
        //   {
        //   if (perdaymin1.length == 1) {
        //     element.hoursPerDayHrMin = perdaymin1[0] + " hr " + "0 Min";
        //   }
        //   else {
        //     let perdaymin2 = 0 + "." + perdaymin1[perdaymin1.length - 1];
        //     element.hoursPerDayHrMin = perdaymin1[0] + " hr " + (parseFloat(perdaymin2) * 60).toString().split('.')[0] + "Min";
        //   }
        //  }
          // hoursPerWeek
        
        //   let perweekmin1 = element?.hoursPerWeek?.toString().split('.');
        
        //   if(perweekmin1!=null && perweekmin1!=undefined && perweekmin1!='')
        //   {
        //   if (perweekmin1.length == 1) {
        //     element.hoursPerWeekHrMin = perweekmin1[0] + " hr " + "0 Min";
        //   }
        //   else {
        //     let perweekmin2 = 0 + "." + perweekmin1[perweekmin1.length - 1];
        //     element.hoursPerWeekHrMin= perweekmin1[0] + " hr " + (parseFloat(perweekmin2) * 60).toString().split('.')[0] + "Min";
        //   }
        // }
          // unitsRemaining
        //   let perunitsRemaining1 = element?.unitsRemaining?.toString().split('.');
          
        //   if(perunitsRemaining1!=null && perunitsRemaining1!=undefined && perunitsRemaining1!='')
        //   {
        //   if (perunitsRemaining1.length == 1) {
        //     element.unitsRemainingHrMin = perunitsRemaining1[0] + " hr " + "0 Min";
        //   }
        //   else {
        //     let perunitsRemaining2 = 0 + "." + perunitsRemaining1[perunitsRemaining1.length - 1];
        //     element.unitsRemainingHrMin = perunitsRemaining1[0] + " hr " + (parseFloat(perunitsRemaining2) * 60).toString().split('.')[0] + "Min";
        //   }
        // }
          // remaingHours
          // let perremaingHours1 = element?.remaingHours?.toString().split('.');
         
          
          // if(perremaingHours1!=null && perremaingHours1!=undefined && perremaingHours1!='')
          // {
          // if (perremaingHours1.length == 1) {
          //   element.remaingHoursHrMin = perremaingHours1[0] + " hr " + "0 Min";
          // }
          // else {
          //   let perremaingHours2 = 0 + "." + perremaingHours1[perremaingHours1.length - 1];
          //   element.remaingHoursHrMin = perremaingHours1[0] + " hr " + (parseFloat(perremaingHours2) * 60).toString().split('.')[0] + "Min";
          // }
          // }
          let obj1 =
          {
            'serialNo': element.serialNo,
            'lineStatus': element.lineStatus,
            'serviceDate': serviceDate,
            'serviceCode':element.serviceCode,
            'dailyHours': element.dailyHours,
            'procedureCode': element.procedureCode,
            'serviceId': element.serviceId,
            // 'HireDate': new Date(704692800000),
            'moD1': element.moD1,
            'moD2': element.moD2,
            'moD3': element.moD3,
            'over275Hrs': element.over275Hrs,
            'remaimimgAuthorizedHours': element.remaimimgAuthorizedHours,
            'overDaily16Hours': element.overDaily16Hours,
            'timesheetNotes': element.timesheetNotes,
            'timeSheetId': element.timeSheetId,
            'bit': element.bit,
            'isApproved':element.isApproved,
            'payDate': this.datePipe.transform(element.paydate, "MM/dd/yyyy"),
            // hoursPerDay
            // 'hoursPerDayHrMin': element.hoursPerDayHrMin,
            // hoursPerWeek
            // 'hoursPerWeekHrMin': element.hoursPerWeekHrMin,
            // unitsRemaining
            // 'unitsRemainingHrMin': element.unitsRemainingHrMin,
            // remaingHours
            // 'remaingHoursHrMin': element.remaingHoursHrMin,

            
            'isPaid':((element.isPaid==true) ? "YES":"NO"),
            'isCertified':element?.isCertified,
            'errorNotes':element?.errorNotes

          }
          childArray.push(obj1);
        });
        parentArray = objArray;
        this.childData = childArray;
      });
      // ----------for splitday data-----------
      data.result.forEach(element => {
        element.lineItem.forEach(element => {
          element.lineItemDetail.forEach(element => {
            let serviceDate = this.datePipe.transform(element.serviceDate, "MM/dd/yyyy")
            let obj2 =
            {
              // 'serialNo': element.serialNo,
              'lineStatus': element.lineStatus,
              'serviceDate': serviceDate,
              'serviceCode':element.serviceCode,
              "dailyHours": element.dailyHours,
              'procedureCode': element.procedureCode,
              'serviceId': element.serviceId,
              // 'HireDate': new Date(704692800000),
              'moD1': element.moD1,
              'moD2': element.moD2,
              'moD3': element.moD3,
              'over275Hrs': element.over275Hrs,
              'remaimimgAuthorizedHours': element.remaimimgAuthorizedHours,
              'overDaily16Hours': element.overDaily16Hours,
              'timesheetNotes': element.timesheetNotes,
              'timeSheetId': element.timeSheetId,
              'isApproved':element.isApproved,            

            }
            this.details.push(obj2)
          });
        });
      });
    }
    else {
      parentArray = []
      this.childData = [];
    }
    return parentArray;
  }
  getserialNo() {
    return this.serialno;
  }
  getChildData() {
    return this.childData;
  }
  getDetails() {
    return this.details;
  }
  getErrorlist() {
    return this.errorlist;
  }
  getwholeData() {
    return this.originaldata;
  }
  getidsList() {
    return this.idsList;
  }
}
